var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSidebarData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "64EDDB5D-0181-4EDC-B258-DB7885EBBD3F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,1 C14.9705627,1 19,5.02943725 19,10 C19,14.9705627 14.9705627,19 10,19 C5.02943725,19 1,14.9705627 1,10 C1,5.02943725 5.02943725,1 10,1 Z M10,3 C6.13400675,3 3,6.13400675 3,10 C3,12.2477989 4.05947976,14.2481431 5.70630475,15.528898 C5.80275466,15.4474582 5.90858553,15.3752431 6.02217391,15.3132609 L7.96152174,14.2554348 C8.14608696,14.1545652 8.26086957,13.9615217 8.26086957,13.751087 L8.26086957,13.0317391 L8.16771538,12.9037581 C7.98234903,12.6376449 7.66528986,12.1155435 7.49934783,11.4584783 C7.29413043,11.293913 7.17391304,11.0471739 7.17391304,10.7826087 L7.17391304,9.91304348 C7.17391304,9.70369565 7.25217391,9.50086957 7.39130435,9.3423913 L7.39130435,8.18608696 L7.38595143,8.10836663 C7.37637874,7.87888502 7.39994203,7.27627536 7.84608696,6.7673913 C8.2926087,6.25826087 9.01717391,6 10,6 C10.9828261,6 11.7073913,6.25826087 12.153913,6.7676087 C12.6686957,7.35478261 12.6208696,8.06652174 12.6086957,8.18608696 L12.6086957,9.3423913 C12.7478261,9.50086957 12.826087,9.70369565 12.826087,9.91304348 L12.826087,10.7826087 C12.826087,11.125 12.6269565,11.4282609 12.3202174,11.568913 C12.1632609,12.0256522 11.9473913,12.4491304 11.6780435,12.8295652 C11.623913,12.906087 11.5715217,12.9754348 11.5217391,13.0363043 L11.5217391,13.7713043 C11.5217391,13.9904348 11.6434783,14.1873913 11.8393478,14.2854348 L13.916087,15.3236957 C14.042908,15.3871268 14.1606214,15.462717 14.2681184,15.5486731 C15.928907,14.2700022 17,12.2600847 17,10 C17,6.13400675 13.8659932,3 10,3 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\u0101kums",
    transform: "translate(-20.000000, -291.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 5,
    transform: "translate(0.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Sidebar-/-Theory",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#667380",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#A7A9AD",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarData);
export default __webpack_public_path__ + "static/media/ic-sidebar-data.9720059d06b897344458b6b03b328120.svg";
export { ForwardRef as ReactComponent };